<template>
  <div class="investment-form">
    <div class="header">
      Contrato e inversión
    </div>
    <div class="form">
      <div class="info-contract">
        <input type="checkbox" v-model="toggle1"> He leído, comprendido y aceptado en su totalidad los <a href="/terms"
        target="_blank">Términos y condiciones de uso de la Plataforma</a>, el <a href="/privacy-policy" target="_blank">
        Aviso de Privacidad de los Datos</a> y el <span @click="downloadContract" style="cursor: pointer;">Contrato
        de inversión</span>, aceptando obligarme en términos de los documentos mencionados.
      </div>
      <div class="info-contract">
        <input type="checkbox" v-model="toggle2"> Declaro bajo protesta de decir verdad que la información y
        documentación proporcionad a Flagship es verídica y no ha sido manipulada o editada de forma alguna, por
        lo que en caso de existir falsedad en ella, tengo pleno conocimiento que se aplicarán las sanciones
        contractuales que correspondan y las penas establecidas en los ordenamientos legales respectivos para
        quienes se conducen con falsedad.
      </div>
      <div class="info-contract">
        <input type="checkbox" v-model="toggle3"> Reconozco y acepto que conozco y entiendo los riesgos que esta
        transacción implica, incluyendo sin limitar la posibilidad de perder el total de mi inversión. Así mismo,
        manifiesto que el monto invertido por mí en este proyecto no afectará ni pondrá en riesgo mi patrimonio de
        manera sustancial.
      </div>
      <div class="info-contract">
        <input type="checkbox" v-model="toggle4"> Me comprometo a realizar en tiempo y forma la
        transferencia electrónica una vez finalizado el periodo de fondeo. Bajo mi conocimiento,
        recibiré las instrucciones vía correo electrónico para llevar a cabo dicha transferencia.
      </div>
    </div>
    <div class="button-wrapper">
      <div class="button" :class="{ disabled: !filled }" @click="submitInvestment">
        Terminar
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import axios from 'axios';
import download from 'downloadjs';

const { mapActions } = createNamespacedHelpers('investment');

export default {
  data() {
    return {
      toggle1: false,
      toggle2: false,
      toggle3: false,
      toggle4: false,
      error: null,
    };
  },
  watch: {
    user() {
      this.data = { ...this.user };
    },
  },
  computed: {
    user() {
      return this.$store.state.user.user;
    },
    filled() {
      return this.toggle1 && this.toggle2 && this.toggle3 && this.toggle4;
    },
  },
  methods: {
    async submitInvestment() {
      if (this.filled) {
        await this.createInvestment({
          projectId: parseInt(this.$route.params.projectId, 10),
          investment: parseInt(this.$route.query.investment, 10),
        });
        this.$emit('finished');
      }
    },
    async downloadContract() {
      const response = await axios.post(`${process.env.VUE_APP_SERVER_URL}/pdf`, { investment: parseInt(this.$route.query.investment, 10), projectId: parseInt(this.$route.params.projectId, 10) }, { responseType: 'blob' });
      download(response.data, 'Contrato.pdf', 'application/pdf');
    },
    ...mapActions([
      'createInvestment',
    ]),
  },
};
</script>

<style lang="scss" scoped>
.investment-form {
  display: flex;
  flex-wrap: wrap;
}
.label {
  width: 100%;
  margin-bottom: 20px;
}
.label--half {
  width: 48%;
}
.label--third {
  width: 30%;
}
.label-text {
  line-height: 18px;
  margin-bottom: 12px;
}
.header {
  width: 100%;
  font-weight: bold;
  font-size: 22px;
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.form {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
/deep/ .form-input {
  font-size: 15px;
  border: none;
  border: 1px solid #d6d6d8;
  padding: 8px;
  font-family: inherit;
  width: 100%;
  border-radius: 4px;

  &:focus {
    border: 1px solid #3479e9;
  }
}
.button-wrapper {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  margin-top: 5px;
}
.button {
  background-color: #3479e9;
  color: white;
  padding: 12px 40px;
  font-size: 16px;
  border-radius: 4px;
  cursor: pointer;
}
.info-contract {
  font-size: 16px;
  margin-bottom: 12px;
  line-height: 1.2rem;
  text-align: justify;

  a {
    color: #2c70c1;
    cursor: pointer;
  }
  span {
    color: #2c70c1;
    cursor: pointer;
  }
}
.disabled {
  background-color: lighten($color: #3479e9, $amount: 20);
  cursor: not-allowed;
}
</style>
